module.exports = __webpack_public_path__ + "static/media/fisdom_logo_icon.1159e348.svg";